export default {
  // 访问的服务器ip地址
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  // api服务前缀
  apiPath: import.meta.env.VITE_API_PATH,
}
